import api from './api';

const path = '/admin/import';

export const getAdminImportAccess = () => api.get(`${path}/access`);
export const readImportSource = (url) => api.post(`${path}/read`, { url });
export const prepareImport = ({ importId, target, seller, photos }) =>
    api.post(`${path}/prepare`, { importId, target, seller, photos });
export const publishImport = ({ importId, target, seller, values }) =>
    api.post(`${path}/publish`, { importId, target, seller, values });
export const listImports = (page = 0) =>
    api.get(`${path}/list`, { params: { page } });
export const manageImport = (id, action) =>
    api.post(`${path}/items/${id}/${action}`);
